import { defineComponent as _defineComponent } from 'vue'
import { computed, PropType } from 'vue';
import useI18n from '@/mixins/useI18n';
import { templateRef } from '@vueuse/core';
import { AtBeforeInputValidation } from '@/models/BcxForm';
import useBeforeInput from '@/mixins/useBeforeInput';


export default /*#__PURE__*/_defineComponent({
  __name: 'BCXCurrencyInput',
  props: {
  value: {
    type: [Number, String],
    default: ''
  },
  disabled: {
    type: Boolean,
    default: false
  },
  currencySymbol: {
    type: String,
    default: ''
  },
  decimals: {
    type: Number,
    default: 2
  },
  spaceCurrencySymbol: {
    type: String,
    default: '28px'
  },
  atBeforeInput: {
    type: Array as PropType<AtBeforeInputValidation[]>,
    default: () => []
  }
},
  emits: ['input'],
  setup(__props, { emit }) {

const props = __props;




const { locale } = useI18n();
const { handleBeforeInputFunctions } = useBeforeInput();



const input = templateRef<HTMLInputElement>('input', null);

const inputValue = computed(() => (typeof props.value === 'string' ? parseFloat(props.value).toFixed(props.decimals) : props.value.toFixed(props.decimals)));

const onChange = () => {
  const value = input.value?.valueAsNumber ?? 0;
  if (typeof props.value === 'number') {
    emit('input', value);
  } else emit('input', `${value}`);
};


return { __sfc: true,props, locale, handleBeforeInputFunctions, emit, input, inputValue, onChange }
}

})